(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["moh-article"]) return;
  try {
    
(function () {
  const d = document;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const io = 'IntersectionObserver' in window;
  const $ = (s, c = d) => c.querySelector(s);
  const $$ = (s, c = d) => Array.from(c.querySelectorAll(s));
  const start = () => {
  /* reading progress on articles */
  if ($('article[data-phase] .m-article__body')) {
    const bar = d.createElement('div'); bar.className = 'm-progress-bar'; d.body.appendChild(bar);
    const upd = () => { const h = d.documentElement; bar.style.setProperty('--p', Math.min(1, window.scrollY / Math.max(1, h.scrollHeight - innerHeight)).toFixed(3)); };
    window.addEventListener('scroll', () => requestAnimationFrame(upd), { passive: true }); upd();
  }
  };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moh-book"] && !Shopify.designMode) return;
  try {
    
(function () {
  const d = document;
  const $ = (s, r = d) => r.querySelector(s);
  const $$ = (s, r = d) => Array.from(r.querySelectorAll(s));
  const start = () => {
  /* catalogue flip-book */
  $$('[data-book]').forEach((book) => {
    const desk = $('[data-book-desk]', book), mob = $('[data-book-mob]', book);
    const sec = book.closest('section');
    const count = $('[data-book-count]', sec);
    const mode = () => (window.matchMedia('(max-width: 749px)').matches ? mob : desk);
    const state = new Map([[desk, 0], [mob, 0]]);
    const render = () => {
      const el = mode(), leaves = $$('[data-leaf]', el), k = state.get(el);
      leaves.forEach((l, i) => l.classList.toggle('is-flipped', i < k));
      if (el === desk) {
        book.classList.toggle('is-mid', k > 0 && k < leaves.length);
        book.classList.toggle('is-end', k === leaves.length);
        count.textContent = k === 0 ? 'Cover' : k === leaves.length ? 'Back cover' : `Pages ${k * 2 - 1}–${k * 2} of 18`;
      } else {
        count.textContent = k === 0 ? 'Cover' : `Page ${k} of ${leaves.length - 1}`;
      }
    };
    const turn = (dir) => {
      const el = mode(), n = $$('[data-leaf]', el).length;
      const k = Math.max(0, Math.min(n - (el === mob ? 1 : 0), state.get(el) + dir));
      const leaf = $$('[data-leaf]', el)[dir > 0 ? state.get(el) : k];
      if (leaf) { leaf.classList.add('is-turning'); setTimeout(() => leaf.classList.remove('is-turning'), 1000); }
      state.set(el, k); render();
    };
    $('[data-book-next]', sec).addEventListener('click', () => turn(1));
    $('[data-book-prev]', sec).addEventListener('click', () => turn(-1));
    book.addEventListener('click', (e) => {
      if (e.target.closest('[data-noflip], a, button, form')) return;
      const leaf = e.target.closest('[data-leaf]'); if (!leaf) return;
      turn(leaf.classList.contains('is-flipped') ? -1 : 1);
    });
    let sx = null;
    book.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; }, { passive: true });
    book.addEventListener('touchend', (e) => { if (sx === null) return; const dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) turn(dx < 0 ? 1 : -1); sx = null; }, { passive: true });
    sec.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') turn(1); if (e.key === 'ArrowLeft') turn(-1); });
    window.addEventListener('resize', render, { passive: true });
    render();
  });

  };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moh-contact"]) return;
  try {
    
(function () {
  const d = document;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const io = 'IntersectionObserver' in window;
  const $ = (s, c = d) => c.querySelector(s);
  const $$ = (s, c = d) => Array.from(c.querySelectorAll(s));
  const start = () => {
  /* ---------- Contact form: prefill subject from query ---------- */
  const topic = new URLSearchParams(location.search).get('topic');
  if (topic) { const f = $('[name="contact[topic]"]'); if (f) f.value = topic; }
  };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moh-header"]) return;
  try {
    
(function () {
  const set = () => { const a = document.querySelector('.m-announce'); if (a) document.documentElement.style.setProperty('--ann-h', Math.round(a.getBoundingClientRect().height)); };
  const start = () => { set(); window.addEventListener('resize', set, { passive: true }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moh-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  const d = document;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const io = 'IntersectionObserver' in window;
  const $ = (s, c = d) => c.querySelector(s);
  const $$ = (s, c = d) => Array.from(c.querySelectorAll(s));
  const start = () => {
  /* hero stage cycling */
  $$('[data-stage]').forEach((st) => {
    const items = $$('[data-stage-item]', st), caps = $$('[data-stage-cap]', st), dots = $$('[data-stage-dot]', st);
    if (items.length < 2) return;
    let i = 0, t;
    const go = (n) => { i = (n + items.length) % items.length; items.forEach((x, k) => x.classList.toggle('is-on', k === i)); caps.forEach((x, k) => x.classList.toggle('is-on', k === i)); dots.forEach((x, k) => x.setAttribute('aria-current', String(k === i))); };
    const play = () => { clearInterval(t); if (!reduce) t = setInterval(() => go(i + 1), 3600); };
    dots.forEach((d) => d.addEventListener('click', () => { go(Number(d.dataset.stageDot)); play(); }));
    st.addEventListener('pointerenter', () => clearInterval(t)); st.addEventListener('pointerleave', play);
    play();
  });


  /* hero arch: match packshot background colour exactly */
  $$('[data-stage]').forEach((st) => {
    const arch = $('.m-stage__arch', st);
    const img = $('[data-stage-item] img', st);
    const sample = () => {
      try {
        const c = d.createElement('canvas'); c.width = c.height = 4;
        const x = c.getContext('2d'); x.drawImage(img, 0, 0, 40, 40, 0, 0, 4, 4);
        const p = x.getImageData(1, 1, 1, 1).data;
        arch.style.background = `rgb(${p[0]},${p[1]},${p[2]})`;
      } catch (e) {}
    };
    if (img) { if (img.complete) sample(); else img.addEventListener('load', sample, { once: true }); }
  });
  };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moh-ingredients"]) return;
  try {
    
(function () {
  const d = document;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const io = 'IntersectionObserver' in window;
  const $ = (s, c = d) => c.querySelector(s);
  const $$ = (s, c = d) => Array.from(c.querySelectorAll(s));
  const start = () => {
  /* ---------- Ingredient finder: what it does · where it is · good to know ---------- */
  // [what it does, good to know]. General role of the ingredient in skincare — written conservatively, no clinical claims.
  const HYA = 'A form of hyaluronic acid. Hyaluronic ingredients attract and hold water, helping skin feel hydrated and supple. Different sizes and forms work at different levels of the skin’s surface.';
  const DICT = {
    'aqua': ['Water — the base of the formula. It dissolves and carries the other ingredients.'],
    'glycerin': ['A humectant: it draws water to the skin and helps it hold on to it. A skincare staple.'],
    'betaine': ['A humectant that helps skin retain moisture and feel comfortable. Often made from sugar beet.'],
    'propanediol': ['A plant-derived humectant and solvent. It helps ingredients blend and skin hold moisture.'],
    'propylene glycol': ['A humectant and solvent that helps other ingredients spread evenly and keeps skin feeling hydrated.'],
    'butylene glycol': ['A humectant and solvent. It helps the formula feel light and helps skin hold moisture.'],
    'pentylene glycol': ['A humectant and solvent that also supports the formula’s preservative system.'],
    'xylitol': ['A sugar-based humectant that helps skin hold water.'],
    'xylitylglucoside': ['A sugar-based humectant, used together with xylitol and anhydroxylitol to help skin hold water.'],
    'anhydroxylitol': ['A sugar-based humectant that works with xylitol to keep skin feeling hydrated.'],
    'saccharide isomerate': ['A sugar-derived ingredient that binds to the skin’s surface and helps it stay hydrated for longer.'],
    'beta-glucan': ['A sugar-type molecule (often from oats or yeast) that helps skin feel soft and comfortable.'],
    'amino acids': ['The building blocks of proteins. They help skin feel hydrated and conditioned.'],
    'inositol': ['A vitamin-like ingredient that helps condition skin and hold moisture.'],
    'biotin': ['Vitamin B7. Used in skincare to condition skin.'],
    'calcium pantothenate': ['A form of vitamin B5. Used to condition skin and help it feel soft.'],
    'niacinamide': ['Vitamin B3. A versatile skin-conditioning ingredient used for a smoother, more even-looking feel.', 'Skin can feel different with niacinamide at first. Introduce gradually and stop if you notice irritation.'],
    'zinc pca': ['A salt of PCA, a component of the skin’s own natural moisturising factor. Helps skin hold water.'],
    'magnesium pca': ['A salt of PCA, a component of the skin’s own natural moisturising factor. Helps skin hold water.'],
    'sodium pca': ['A component of the skin’s own natural moisturising factor. Helps skin hold water.'],
    'ascorbic acid': ['Vitamin C — an antioxidant used to condition skin.', 'Vitamin C can tingle on some skin. Introduce gradually.'],
    'tocopherol': ['Vitamin E — an antioxidant. It also helps protect the oils in the formula from going off.'],
    'terminalia ferdinandiana fruit extract': ['Kakadu plum extract — a fruit extract naturally rich in vitamin C, used as an antioxidant.'],
    'multi-layer hyaluronic complex': ['A blend of hyaluronic acid forms of different sizes, so hydration works at more than one level of the skin’s surface.'],
    'ceramide np': ['A ceramide — a lipid that is part of the skin’s own barrier. Helps support the barrier and keep moisture in.'],
    'ceramide ap': ['A ceramide — a lipid that is part of the skin’s own barrier. Helps support the barrier and keep moisture in.'],
    'ceramide as': ['A ceramide — a lipid that is part of the skin’s own barrier. Helps support the barrier and keep moisture in.'],
    'ceramide eop': ['A ceramide — a lipid that is part of the skin’s own barrier. Helps support the barrier and keep moisture in.'],
    'ceramide ns': ['A ceramide — a lipid that is part of the skin’s own barrier. Helps support the barrier and keep moisture in.'],
    'cholesterol': ['A natural skin-barrier lipid. Works alongside ceramides to support the skin’s moisture barrier.'],
    'hydrogenated lecithin': ['A lecithin-derived ingredient that helps oil and water mix and conditions skin; it also works well with barrier lipids.'],
    'soy lecithin': ['An emulsifier and conditioning ingredient from soybeans.', 'Soy-derived. If you have a soy allergy, check with your doctor.'],
    'cetyl alcohol': ['A fatty alcohol — it thickens and softens. It is not a drying alcohol.'],
    'cetearyl alcohol': ['A fatty alcohol — it thickens and softens. It is not a drying alcohol.'],
    'glyceryl monostearate': ['An emulsifier and thickener that helps creams blend and feel smooth.'],
    'glyceryl stearate': ['An emulsifier and thickener that helps creams blend and feel smooth.'],
    'cetearyl olivate': ['An olive-derived emulsifier that helps oil and water mix.'],
    'sorbitan olivate': ['An olive-derived emulsifier that helps oil and water mix.'],
    'sorbitan laurate': ['An emulsifier that helps oil and water mix.'],
    'sucrose distearate': ['A sugar-derived emulsifier that helps oil and water mix.'],
    'trideceth-6': ['An emulsifier that helps oil and water mix.'],
    'candida bombicola/glucose/methyl rapeseedate ferment': ['A fermentation-derived ingredient that helps oil and water mix and conditions skin.'],
    'xanthan gum': ['A thickener made by fermentation. It gives the formula its texture and helps keep it stable.'],
    'sodium acrylate/sodium acryloyldimethyl taurate copolymer': ['A texture polymer. It gives the cushiony, smooth feel of the formula.'],
    'guar hydroxypropyltrimonium chloride': ['A conditioning polymer from guar. It helps the formula glide and leaves skin feeling soft.'],
    'zea mays starch': ['Corn starch. It adds a soft, smooth finish to the formula.'],
    'dimethicone': ['A silicone that gives slip and a smooth feel, and forms a light protective film on the skin.'],
    'hydrogenated polydecene': ['A lightweight emollient that gives a silky feel.'],
    'c13-15 alkane': ['A lightweight emollient that helps the cream spread and feel non-greasy.'],
    'c15-19 alkane': ['A lightweight emollient that helps the cream spread and feel non-greasy.'],
    'caprylic/capric triglyceride': ['A light, skin-softening emollient made from coconut oil and glycerin.', 'Coconut-derived. If you find coconut-based ingredients heavy on your skin, patch test first.'],
    'butyrospermum parkii butter': ['Shea butter — a rich emollient that softens skin and helps seal in moisture.', 'Shea comes from a tree nut. If you have a tree-nut allergy, check with your doctor.'],
    'cocos nucifera oil': ['Coconut oil — a rich emollient that softens skin and lips.', 'If you find coconut oil heavy or clogging on your skin, patch test first.'],
    'simmondsia chinensis seed oil': ['Jojoba oil — a liquid wax close in feel to the skin’s own oils. Softens and conditions.'],
    'olea europaea fruit oil': ['Olive oil — an emollient that softens and conditions skin.'],
    'helianthus annuus seed oil': ['Sunflower seed oil — a light emollient rich in linoleic acid. Softens skin.'],
    'argania spinosa kernel oil': ['Argan oil — an emollient oil that softens and conditions skin.'],
    'hippophae rhamnoides fruit oil': ['Sea buckthorn oil — a nourishing oil with a natural orange colour. Helps skin feel soft and supple.', 'Naturally orange, so it can lend a slight tint to the formula.'],
    'rosa canina seed oil': ['Rosehip seed oil — a light, fatty-acid-rich emollient that softens skin.'],
    'prunus amygdalus dulcis oil': ['Sweet almond oil — an emollient oil that softens and conditions skin.', 'Nut-derived. If you have a nut allergy, check with your doctor before using.'],
    'rubus idaeus seed oil': ['Raspberry seed oil — an emollient oil that softens and conditions lips and skin.'],
    'centella asiatica oil': ['Centella (cica) oil — a plant oil used to condition and comfort skin.'],
    'cera alba': ['Beeswax — gives balms their structure and leaves a light protective film.', 'Animal-derived (not vegan).'],
    'euphorbia cerifera wax': ['Candelilla wax — a plant wax that gives lip balm its structure and light protective film.'],
    'angelica gigas root extract': ['A root extract from Korean angelica. Used to condition skin.'],
    'lithospermum erythrorhizon root extract': ['An extract from gromwell root. Used to condition skin.'],
    'glycyrrhiza uralensis root extract': ['A licorice root extract. Used to condition skin.'],
    'glycyrrhiza glabra root extract': ['A licorice root extract. Used to condition skin.'],
    'arctostaphylos uva ursi leaf extract': ['Bearberry leaf extract. A plant extract used to condition skin.'],
    'citrus sinensis fruit extract': ['An orange fruit extract. Used to condition skin.', 'Citrus-derived. People with very sensitive skin may want to patch test first.'],
    'cucumis sativus fruit extract': ['Cucumber extract. A plant extract used to condition skin and leave it feeling fresh.'],
    'dioscorea villosa root extract': ['Wild yam root extract. A plant extract used to condition skin.'],
    'saccharomyces ferment lysate filtrate': ['A yeast ferment. Used to condition skin.'],
    'bifida ferment filtrate': ['A probiotic-derived ferment. Used to condition skin.'],
    'phenoxyethanol': ['A preservative. It keeps the formula safe from bacteria and mould over its shelf life.', 'Used at the low levels allowed for cosmetics. Very sensitive skin can occasionally react to any preservative — patch test if unsure.'],
    'ethylhexylglycerin': ['A skin-conditioning ingredient that also supports the preservative system.'],
    'sodium benzoate': ['A preservative that keeps the formula stable over time.'],
    'sodium gluconate': ['Helps keep the formula stable and conditions skin.'],
    'butylated hydroxytoluene': ['An antioxidant that protects the oils in the formula from going off.'],
    'fragrance': ['Scents the product.', 'Fragrance can be a trigger for some sensitive skin. Patch test if you tend to react to scented products. By law, individual fragrance components are not itemised.'],
    'parfum': ['Scents the product.', 'Fragrance can be a trigger for some sensitive skin. Patch test if you tend to react to scented products.'],
    'flavor': ['Gives the lip balm its taste.', 'If your lips tend to react to flavoured products, patch test first.'],
    'mica': ['A mineral that adds a soft shimmer and glow.'],
    'ci 77491': ['Iron oxide (red) — a mineral colourant that gives the shade its colour.'],
    'ci 77492': ['Iron oxide (yellow) — a mineral colourant that gives the shade its colour.'],
    'ci 77499': ['Iron oxide (black) — a mineral colourant that deepens the shade.'],
    'ci 77891': ['Titanium dioxide — a mineral pigment that adds opacity and brightness to the shade.'],
    'ci 77861': ['Tin oxide — a mineral that helps give the shade its finish.'],
    'curcumin': ['The colour compound from turmeric. A natural yellow colourant.', 'Can lend a very slight yellow tint.'],
    'rutin': ['A plant flavonoid used as an antioxidant to condition lips.'],
    'nonapeptide-1': ['A peptide — a short chain of amino acids — used to condition skin and lips.'],
    'oligopeptide-68': ['A peptide — a short chain of amino acids — used to condition skin and lips.'],
    'decapeptide-12': ['A peptide — a short chain of amino acids — used to condition skin and lips.'],
    'acetyl glycyl beta-alanine': ['A small peptide-type ingredient used to condition lips and leave them feeling smooth.']
  };
  const norm = (n) => n.toLowerCase().replace(/\*/g, '').replace(/\s*\([^)]*\)/g, '').replace(/\s+/g, ' ').trim();
  const info = (name) => {
    const k = norm(name);
    if (DICT[k]) return DICT[k];
    if (k.includes('hyaluron')) return [HYA, k.includes('retinoyl') ? 'Contains a retinoid-derived part. If you are pregnant, breastfeeding or using prescription retinoids, check with your doctor.' : ''];
    if (k.startsWith('ci 77')) return ['A mineral colourant that gives the shade its colour.'];
    if (k.endsWith('extract')) return ['A plant extract used to condition skin.'];
    return ['Listed in full on the product’s ingredient list. Ask us and we’ll gladly explain what it does.'];
  };
  // split an INCI string on commas that are not inside brackets
  const splitInci = (t) => { const out = []; let d = 0, cur = ''; for (const ch of t) { if (ch === '(') d++; if (ch === ')') d--; if (ch === ',' && d === 0) { out.push(cur.trim()); cur = ''; } else cur += ch; } if (cur.trim()) out.push(cur.trim()); return out.map((x) => x.replace(/\.$/, '').trim()).filter(Boolean); };

  const idx = new Map(); // normalised name -> { name, in: Map(product -> {url, shades:Set}) }
  const addTo = (name, prod, url, shade) => {
    const k = norm(name); if (!k) return;
    if (!idx.has(k)) idx.set(k, { name: name.replace(/\*/g, '').replace(/\s*\([^)]*\)/g, (m) => (/CI|Mica|Beeswax|Sweet|Shea|Coconut|Olive|Sunflower|Jojoba|Orange|Cucumber|Sea|Kakadu|Wild|Raspberry|Fragrance/i.test(m) ? m : '')).trim() || name, in: new Map() });
    const e = idx.get(k); if (!e.in.has(prod)) e.in.set(prod, { url, shades: new Set() }); if (shade) e.in.get(prod).shades.add(shade);
  };
  $$('[data-inci-raw]').forEach((box) => {
    const prod = box.dataset.product, url = box.dataset.url, shade = box.dataset.shade;
    const raw = box.textContent.trim();
    const items = splitInci(raw);
    box.textContent = '';
    items.forEach((it) => {
      const m = it.match(/^(.*?)\*?\s*\(includes\s+(.*)\)$/i);
      const main = m ? m[1].trim() + '*' : it;
      const sp = d.createElement('span'); sp.textContent = main; box.appendChild(sp);
      addTo(it.replace(/\*?\s*\(includes.*$/i, ''), prod, url, shade);
      if (m) m[2].split(',').forEach((c) => addTo(c.trim(), prod, url, shade));
    });
    const mm = raw.match(/\(includes\s+(.*?)\)/i);
    if (mm) { const note = d.createElement('p'); note.className = 'm-tiny'; note.textContent = '*Includes ' + mm[1]; box.after(note); }
  });

  const out = $('[data-find-out]');
  const render = (q) => {
    out.innerHTML = '';
    if (!q || q.length < 2) return;
    const terms = q.toLowerCase();
    const hits = [...idx.entries()].filter(([k, e]) => k.includes(terms) || e.name.toLowerCase().includes(terms) || info(e.name)[0].toLowerCase().includes(terms)).sort((a, b) => (a[0].startsWith(terms) ? 0 : 1) - (b[0].startsWith(terms) ? 0 : 1) || a[0].localeCompare(b[0])).slice(0, 6);
    if (!hits.length) { const p = d.createElement('p'); p.className = 'm-find__hint'; p.textContent = 'No ingredient with that name in our formulas. Try a different word — or ask us, we’ll gladly explain.'; out.appendChild(p); return; }
    hits.forEach(([k, e]) => {
      const [does, know] = info(e.name);
      const card = d.createElement('article'); card.className = 'm-find__card';
      const h = d.createElement('h3'); h.className = 'm-find__name'; h.textContent = e.name; card.appendChild(h);
      const p1 = d.createElement('p'); p1.className = 'm-find__does'; p1.textContent = does; card.appendChild(p1);
      const inn = d.createElement('div'); inn.className = 'm-find__in'; inn.append('Found in:');
      e.in.forEach((v, prod) => { const a = d.createElement('a'); a.href = v.url; a.textContent = prod + (v.shades.size && v.shades.size < 4 ? ' (' + [...v.shades].join(', ') + ')' : ''); inn.appendChild(a); });
      card.appendChild(inn);
      if (know) { const p2 = d.createElement('p'); p2.className = 'm-find__know'; p2.textContent = know; card.appendChild(p2); }
      out.appendChild(card);
    });
    const f = d.createElement('p'); f.className = 'm-find__foot'; f.textContent = 'This is the ingredient’s general role in skincare — not a medical claim. Skin is personal: introduce new products gradually and stop if irritation occurs.'; out.appendChild(f);
  };
  $$('[data-inci-search]').forEach((input) => {
    input.addEventListener('input', () => {
      const q = input.value.trim().toLowerCase();
      render(q);
      $$('.m-inci-list span').forEach((s) => s.classList.toggle('is-key', q.length > 1 && s.textContent.toLowerCase().includes(q)));
    });
  });
  };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moh-letter"] && !Shopify.designMode) return;
  try {
    
(function () {
  const d = document;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const io = 'IntersectionObserver' in window;
  const $ = (s, c = d) => c.querySelector(s);
  const $$ = (s, c = d) => Array.from(c.querySelectorAll(s));
  const start = () => {
  $$('[data-env2]').forEach((e) => {
    const b = $('[data-env2-toggle]', e), c = $('[data-env2-close]', e);
    let t1;
    const open = () => {
      clearTimeout(t1); e.classList.add('is-open'); b.setAttribute('aria-expanded', 'true');
      t1 = setTimeout(() => e.classList.add('is-out'), reduce ? 0 : 2100);
    };
    const close = () => {
      clearTimeout(t1); e.classList.remove('is-out'); b.setAttribute('aria-expanded', 'false');
      e.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      t1 = setTimeout(() => e.classList.remove('is-open'), reduce ? 0 : 700);
    };
    b.addEventListener('click', () => (e.classList.contains('is-open') ? close() : open()));
    if (c) c.addEventListener('click', close);
  });
  };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moh-phase-page"]) return;
  try {
    
(function () {
  const d = document;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const io = 'IntersectionObserver' in window;
  const $ = (s, c = d) => c.querySelector(s);
  const $$ = (s, c = d) => Array.from(c.querySelectorAll(s));
  const start = () => {
  /* ---------- Find your phase quiz (recommendation matrix) ---------- */
  $$('[data-quiz]').forEach((quiz) => {
    const box = $('[data-routine]', quiz), am = $('[data-am]', quiz), pm = $('[data-pm]', quiz);
    const names = { C: 'Comfort', N: 'Nourish', S: 'Support', A: 'Admire' };
    const cards = $$('[data-phase-card]');
    const tpl = (h) => { const t = $('template[data-prod="' + h + '"]', quiz); if (!t) return null; const n = t.content.firstElementChild.cloneNode(true); $$('img', n).forEach((i) => { i.loading = 'eager'; i.removeAttribute('data-lazy'); }); return n; };
    const resolve = (P) => {
      const C = P.has('C'), N = P.has('N'), S = P.has('S'), A = P.has('A');
      let m = [], e = [];
      if (S) { m = N ? ['smoglow', 'skin-cushion'] : C ? ['smoglow'] : ['smoglow', 'dream-cream']; e = ['smoglow', 'dream-cream']; }
      else if (N) { m = ['skin-cushion']; e = ['dream-cream']; }
      else if (C) { m = ['dream-cream']; e = ['dream-cream']; }
      if (A) m = m.concat('glow-balms');
      return { m, e };
    };
    const fill = (ol, list, empty) => {
      ol.innerHTML = '';
      if (!list.length) { const li = d.createElement('li'); li.className = 'm-rstep m-rstep--none'; li.textContent = empty; ol.append(li); return; }
      list.forEach((h) => { const n = tpl(h); if (n) ol.append(n); });
    };
    const update = () => {
      const on = $$('.m-chip[aria-pressed="true"]', quiz);
      if (!on.length) { box.hidden = true; cards.forEach((c) => c.classList.remove('is-match')); return; }
      const P = new Set(); on.forEach((c) => c.dataset.ph.split('').forEach((x) => P.add(x)));
      const r = resolve(P);
      fill(am, r.m, 'No additional step'); fill(pm, r.e, 'No additional step');
      $('[data-routine-phases]', quiz).textContent = ['C', 'N', 'S', 'A'].filter((x) => P.has(x)).map((x) => names[x]).join(' + ');
      const sel = on.map((c) => Number(c.dataset.n));
      $('[data-sens]', quiz).hidden = !((sel.includes(1) || sel.includes(6)) && (r.m.includes('smoglow') || r.e.includes('smoglow')));
      cards.forEach((c) => c.classList.toggle('is-match', P.has(c.dataset.phaseCard[0].toUpperCase())));
      box.hidden = false;
    };
    quiz.addEventListener('click', (e) => {
      const chip = e.target.closest('.m-chip');
      if (chip) { chip.setAttribute('aria-pressed', String(chip.getAttribute('aria-pressed') !== 'true')); update(); return; }
      const add = e.target.closest('[data-routine-add]');
      if (add) {
        const ids = [...new Set($$('.m-rstep[data-id]', box).map((x) => x.dataset.id))].map(Number);
        if (ids.length) window.MOH.addItems(ids.map((id) => ({ id, quantity: 1 })), add);
      }
    });
  });
  };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moh-phase-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  const d = document;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const io = 'IntersectionObserver' in window;
  const $ = (s, c = d) => c.querySelector(s);
  const $$ = (s, c = d) => Array.from(c.querySelectorAll(s));
  const start = () => {
  const tabs = (root, tabSel, panelSel, key) => {
    $$(tabSel, root).forEach((t) => t.addEventListener('click', () => {
      const i = t.dataset[key];
      $$(tabSel, root).forEach((x) => x.setAttribute('aria-selected', String(x === t)));
      $$(panelSel, root).forEach((p) => p.classList.toggle('is-on', p.dataset[key.replace('tab', 'panel')] === i));
    }));
  };
  $$('[data-ptabs]').forEach((r) => tabs(r, '[data-ptab]', '[data-ppanel]', 'ptab'));
  };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moh-phases"] && !Shopify.designMode) return;
  try {
    
(function () {
  const d = document;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const io = 'IntersectionObserver' in window;
  const $ = (s, c = d) => c.querySelector(s);
  const $$ = (s, c = d) => Array.from(c.querySelectorAll(s));
  const start = () => {
  /* phases section: wash the section colour to the card in view */
  const pw = $('#phases');
  if (pw && io && !reduce) {
    pw.classList.add('m-phases-wash');
    const cards = $$('.m-phase', pw);
    const obs = new IntersectionObserver((es) => es.forEach((en) => { if (en.isIntersecting && en.intersectionRatio > 0.6) pw.style.backgroundColor = getComputedStyle(en.target).backgroundColor.replace('rgb(', 'rgba(').replace(')', ', 0.45)'); }), { threshold: [0.6, 0.9] });
    cards.forEach((c) => obs.observe(c));
  }
  };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moh-product"]) return;
  try {
    
(function () {
  const d = document;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const io = 'IntersectionObserver' in window;
  const $ = (s, c = d) => c.querySelector(s);
  const $$ = (s, c = d) => Array.from(c.querySelectorAll(s));
  const start = () => {
  /* ---------- PIN code delivery check (client-side, no third-party calls) ---------- */
  const ZONES = { 1: 'Delhi, Haryana, Punjab, Himachal, J&K', 2: 'Uttar Pradesh & Uttarakhand', 3: 'Rajasthan & Gujarat', 4: 'Maharashtra, Goa, MP & Chhattisgarh', 5: 'Karnataka, Telangana & Andhra Pradesh', 6: 'Tamil Nadu & Kerala', 7: 'West Bengal, Odisha & the North East', 8: 'Bihar & Jharkhand', 9: 'Army Postal Service' };
  $$('[data-pin]').forEach((form) => {
    const out = $('.m-pin__out', form.parentElement);
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const v = (form.pin.value || '').replace(/\D/g, '');
      out.classList.remove('is-err');
      if (!/^[1-9][0-9]{5}$/.test(v)) { out.textContent = 'Please enter a valid 6-digit PIN code.'; out.classList.add('is-err'); return; }
      const zone = ZONES[v[0]] || 'India';
      const base = new Date();
      const addBiz = (n) => { const t = new Date(base); let c = 0; while (c < n) { t.setDate(t.getDate() + 1); if (t.getDay() !== 0) c++; } return t; };
      const f = (t) => t.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
      out.textContent = `Yes — we deliver to ${v} (${zone}). Dispatched in 2–3 business days; usually with you between ${f(addBiz(5))} and ${f(addBiz(10))}.`;
    });
  });

  /* ---------- Galleries + rails ---------- */
  $$('[data-gallery]').forEach((g) => {
    const rail = $('.m-gallery__rail', g);
    const btns = $$('[data-goto]', g);
    if (!rail) return;
    const slides = Array.from(rail.children);
    const set = (i) => btns.forEach((b) => b.setAttribute('aria-current', String(Number(b.dataset.goto) === i)));
    btns.forEach((b) => b.addEventListener('click', () => {
      const i = Number(b.dataset.goto);
      rail.scrollTo({ left: slides[i].offsetLeft - rail.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      set(i);
    }));
    let t;
    rail.addEventListener('scroll', () => { clearTimeout(t); t = setTimeout(() => set(Math.round(rail.scrollLeft / rail.clientWidth)), 60); }, { passive: true });
  });
  /* ---------- Sticky buy bar (mobile PDP) ---------- */
  const buy = $('[data-buy-anchor]');
  const sticky = $('.m-sticky-buy');
  if (buy && sticky && io) {
    new IntersectionObserver(([e]) => sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(buy);
  }

  /* PDP gallery zoom origin */
  $$('.m-gallery__rail .m-frame').forEach((f) => f.addEventListener('pointermove', (e) => {
    const r = f.getBoundingClientRect();
    f.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
    f.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
  }));

  /* variant pickers */
  $$('form[data-add] [data-opts]').forEach((box) => {
    const form = box.closest('form'), data = JSON.parse($('[data-variants]', box).textContent);
    const idIn = $('input[name="id"]', box), sec = box.closest('.m-pdp') || d;
    const money = (c) => '₹' + (c / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 });
    const pick = () => {
      const vals = $$('.m-opt', box).map((f) => { const r = $('input:checked', f); $('[data-opt-label]', f).textContent = r ? r.value : ''; return r ? r.value : null; });
      const v = data.find((x) => x.options.every((o, i) => o === vals[i]));
      const btn = $('[type="submit"]', form), lab = $('[data-add-label]', form), stick = $('.m-sticky-buy .m-btn');
      if (!v) { if (btn) btn.disabled = true; if (lab) lab.textContent = 'Unavailable'; return; }
      idIn.value = v.id;
      const qin = $('[data-qty-in]', form); if (qin) { const mx = v.inventory_management === 'shopify' && v.inventory_policy === 'deny' && v.inventory_quantity > 0 ? Math.min(99, v.inventory_quantity) : 99; qin.max = mx; if (Number(qin.value) > mx) qin.value = mx; }
      const pr = $('[data-price]', sec); if (pr) pr.textContent = money(v.price);
      const sp = $('[data-sticky-price]', d); if (sp) sp.textContent = money(v.price) + ' · incl. GST';
      if (btn) btn.disabled = !v.available; if (stick) stick.disabled = !v.available;
      if (lab) lab.textContent = v.available ? 'Add to Care Cart' : 'Coming back soon';
      $$('[data-inci-shade]').forEach((x) => { x.hidden = !vals.includes(x.dataset.inciShade); });
      history.replaceState(null, '', '?variant=' + v.id);
      const mid = v.featured_media && v.featured_media.id; const fr = mid && $('.m-gallery [data-media="' + mid + '"]');
      if (fr) fr.scrollIntoView({ block: 'nearest', inline: 'start', behavior: reduce ? 'auto' : 'smooth' });
    };
    box.addEventListener('change', pick);
  });
  };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moh-reasons"] && !Shopify.designMode) return;
  try {
    
(function () {
  const d = document;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const io = 'IntersectionObserver' in window;
  const $ = (s, c = d) => c.querySelector(s);
  const $$ = (s, c = d) => Array.from(c.querySelectorAll(s));
  const start = () => {
  const tabs = (root, tabSel, panelSel, key) => {
    $$(tabSel, root).forEach((t) => t.addEventListener('click', () => {
      const i = t.dataset[key];
      $$(tabSel, root).forEach((x) => x.setAttribute('aria-selected', String(x === t)));
      $$(panelSel, root).forEach((p) => p.classList.toggle('is-on', p.dataset[key.replace('tab', 'panel')] === i));
    }));
  };
  $$('[data-reasons]').forEach((r) => tabs(r, '[data-rtab]', '[data-rpanel]', 'rtab'));
  };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moh-ring"] && !Shopify.designMode) return;
  try {
    
(function () {
  const d = document;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const io = 'IntersectionObserver' in window;
  const $ = (s, c = d) => c.querySelector(s);
  const $$ = (s, c = d) => Array.from(c.querySelectorAll(s));
  const start = () => {
  $$('[data-ring]').forEach((ring) => {
    const stage = $('.m-ring__stage', ring);
    let ry = 0, vel = reduce ? 0 : 0.12, drag = false, lx = 0, inView = true;
    if (io) new IntersectionObserver(([en]) => { inView = en.isIntersecting; }).observe(ring);
    ring.addEventListener('pointerdown', (e) => { drag = true; lx = e.clientX; ring.setPointerCapture(e.pointerId); });
    ring.addEventListener('pointermove', (e) => { if (!drag) return; const dx = e.clientX - lx; lx = e.clientX; ry += dx * 0.35; vel = dx * 0.05; });
    const up = () => { drag = false; };
    ring.addEventListener('pointerup', up); ring.addEventListener('pointercancel', up);
    const tick = () => {
      if (inView && !drag) { ry += vel; vel += ((reduce ? 0 : 0.12) - vel) * 0.03; }
      stage.style.setProperty('--ry', ry.toFixed(2) + 'deg');
      requestAnimationFrame(tick);
    };
    tick();
  });
  };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moh-shelf"]) return;
  try {
    
(function () {
  const d = document;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const io = 'IntersectionObserver' in window;
  const $ = (s, c = d) => c.querySelector(s);
  const $$ = (s, c = d) => Array.from(c.querySelectorAll(s));
  const start = () => {
  /* shelf filter without reload (FLIP-lite) */
  $$('[data-shelf-filter]').forEach((nav) => {
    const grid = $('[data-shelf-grid]');
    if (!grid) return;
    nav.addEventListener('click', (e) => {
      const a = e.target.closest('a[data-phase]');
      if (!a || e.metaKey || e.ctrlKey) return;
      e.preventDefault();
      const ph = a.dataset.phase;
      $$('a', nav).forEach((x) => x.removeAttribute('aria-current'));
      a.setAttribute('aria-current', 'page');
      $$('.m-card', grid).forEach((c) => {
        const show = !ph || c.dataset.phase === ph;
        c.toggleAttribute('data-hide', !show);
        if (show) { c.style.animation = 'none'; void c.offsetWidth; c.style.animation = ''; }
      });
      history.replaceState(null, '', a.href);
    });
  });
  };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moh-stories-teaser"] && !Shopify.designMode) return;
  try {
    
(function () {
  const d = document;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const io = 'IntersectionObserver' in window;
  const $ = (s, c = d) => c.querySelector(s);
  const $$ = (s, c = d) => Array.from(c.querySelectorAll(s));
  const start = () => {
  /* sticky story cards index */
  $$('.m-stack-cards > .m-feature').forEach((f, i) => f.style.setProperty('--n', i));
  };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();

  } catch(e) { console.error(e); }
})();
})();
